import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'motn-copy-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './copy-toast.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./copy-toast.component.scss']
})
export class CopyToastComponent {
  @Input() show: boolean = false;
  @Input() message: string = 'Copied to clipboard';
  @Input() icon: string = 'fa-check-circle';
  @Input() duration: number = 2000;
}